import { createModalHook } from '../../hooks/useModal'

export const useEditMobileNumberModal = createModalHook()
